"use strict";

require('./CompanyPublicationKeypassService.js');
var moment = require('moment');

function uuidV4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random()*16|0;
    var v = c === 'x' ? r : (r&0x3|0x8);

    return v.toString(16);
  });
}

var DEFAULT_KEYPASS = {
 "information": []
};

var DEFAULT_INFO = {
  "name": "",
  "url": "",
  "username": "",
  "password": "",
  "additional_information": "",
  "isNew": true,
  "isEdit": true
};

CompanyPublicationKeypassCtrl.$inject = ["$scope", "$stateParams", "$translate", "growl", "clipboard", "CompanyPublicationKeypassService", "$filter", "$modal"];
function CompanyPublicationKeypassCtrl($scope, $stateParams, $translate, growl, clipboard, CompanyPublicationKeypassService, $filter, $modal) {

  $scope.informations = []; 
  $scope.keypass = angular.copy(new CompanyPublicationKeypassService(DEFAULT_KEYPASS));
  CompanyPublicationKeypassService.get({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId}, function(resp) {
    if (angular.isDefined(resp.id)) {
      $scope.keypass = resp;     
      $scope.keypass.information = $filter('orderBy')($scope.keypass.information, 'name');
    }
    if ($scope.keypass.information === null) {
      $scope.keypass.information = [];
    }
    angular.forEach($scope.keypass.information, function(value, key){
      var reminderTime = moment(value.last_change_at).add(parseInt($scope.info.extra.passwordChangeNr), 'day'+($scope.info.extra.passwordChangeNr > 1 ? 's':''));
      if(reminderTime < (new Date())){
        $scope.keypass.information[key].reminder = true;
      }
    });
  });

  $scope.updateInfo = function() {
    $scope.keypass.$update({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId}, function(resp){
      $scope.keypass = resp;
      $scope.keypass.information = $filter('orderBy')($scope.keypass.information, 'name');
      angular.forEach($scope.keypass.information, function(value, key){
        var reminderTimeUpdate = moment(value.last_change_at).add(parseInt($scope.info.extra.passwordChangeNr), 'day'+($scope.info.extra.passwordChangeNr > 1 ? 's':''));
        if(reminderTimeUpdate < (new Date())){
          $scope.keypass.information[key].reminder = true;
        }
      });
      growl.addSuccessMessage($translate.instant('keypass.save-success'));
    }, function(){
      growl.addErrorMessage($translate.instant('keypass.save-failure'));
    });
  };

  $scope.addInfo = function() {
    DEFAULT_INFO.id = uuidV4();
    $scope.keypass.information.push(angular.copy(DEFAULT_INFO));
    $scope.keypass.information = $filter('orderBy')($scope.keypass.information, 'name');
  };

  $scope.supported = true;
  if (!clipboard.supported) {
      $scope.supported = false;
  }

  $scope.success = function () {
      growl.addSuccessMessage($translate.instant('keypass.copied'));
  };

  $scope.fail = function (err) {
      growl.addSuccessMessage($translate.instant(err));
  };

  $scope.removeInfo = function(index) {
    $scope.keypass.information.splice(index, 1);
  };

  var angularModal;
  $scope.showModalDeleteKeypass = function(index) {
     angularModal = $modal({
      scope: $scope,
      prefixEvent: "modalKeypass",
      controller: ['$scope', function($scope) {
        $scope.confirmName = $translate.instant('keypass.confirm-delete');
        $scope.activeDelete = function() {
          $scope.removeInfo(index);
          $scope.updateInfo();
        };
      }],
      templateUrl: 'partials/company/publications/detail/latest/confirm-delete.html',
      show: true,
    });
  };

  $scope.$on('modalKeypass.hide', function(){
    angularModal.destroy();
    angularModal = null;
  });
}

angular.module("dokiv")
  .controller("CompanyPublicationKeypassCtrl", CompanyPublicationKeypassCtrl);


//////////////////
// WEBPACK FOOTER
// ./scripts/company/publications/CompanyPublicationKeypassCtrl.js
// module id = 379
// module chunks = 0